






















































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft3sticks from "@/common/components/icons/IconArrowLeft3sticks.vue";
import TheTemplateJ from "@/general/components/templates/TheTemplateJ.vue";
import J03AResultScreen from "@/general/components/pages/parts/ThanksPointSearchMore/J03AResultScreen.vue";
import { Prop, Component, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import { ListResponse, ThanksPoint } from "@/general/store/models";
import ThanksPointApi from "@/general/api/thanksPointApi";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    IconBase,
    IconArrowLeft3sticks,
    TheTemplateJ,
    J03AResultScreen
  }
})
export default class ThanksPointSearchMore extends Vue {
  @Prop({ type: Array, default: [] }) messagesSearchResults!: any;
  @Prop({ type: [Boolean, Number], default: false })
  messagesSearchResultsCount!: boolean | number;
  @Prop({ type: Array, default: ["unreadCount"] }) excludeContents!: any;
  @Prop({ type: String, default: "メッセージ" }) heading!: string;
  @Prop({ type: String, default: "message" }) sectionType!: string;

  searchKeyword = "";
  usersSearchResults: any = [];
  currentPage = 1;
  user = 0;

  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: `${SITE_MAP.THANKS_POINT_USER_SPECIFIC}?`
  };

  breadcrumb: any = [
    {
      text: "",
      url: SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "サンクスメッセージ",
      url: "",
      pageType: "lower"
    }
  ];

  get maxPage() {
    return this.pageNavi.maxPage;
  }

  get nextPageUrl() {
    return this.pageNavi.nextPageUrl;
  }

  get prevPageUrl() {
    return this.pageNavi.prevPageUrl;
  }

  get baseUrl() {
    return this.pageNavi.baseUrl;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    this.breadcrumb[1].text = this.thanksPointName + "メッセージ"
    await commons.setbreadcrumb(this.breadcrumb);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pageParam = urlParams.get("page");
    const search = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : undefined;
    if (search !== undefined) {
      this.searchKeyword = search;
    }
    const id = urlParams.get("id")
      ? (urlParams.get("id") as string)
      : undefined;
    const userString = id as string;
    const user = parseInt(userString);
    let currentPage = 1;
    if (id === undefined) {
      currentPage = pageParam ? parseInt(pageParam) : 2;
    } else {
      currentPage = pageParam ? parseInt(pageParam) : 1;
    }

    this.currentPage = currentPage;
    this.user = user;
    await this.getThankPoint(this.currentPage, this.searchKeyword, this.user);
    this.handleURL();
  }

  get backUrl() {
    return `${SITE_MAP.THANKS_POINT}?search=${this.searchKeyword}&page=1`;
  }

  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }

  async getThankPoint(
    currentPage: number,
    search: string | undefined,
    user: number
  ) {
    this.user = user;
    this.currentPage = currentPage;
    this.searchKeyword = search as string;

    const thanksPointList: ListResponse<ThanksPoint> = await ThanksPointApi.getThankPointList(
      this.currentPage,
      this.pageSize,
      this.searchKeyword,
      this.user
    );
    // DC_IC-942
    thanksPointList.results?.forEach((resObj) => {
      this.usersSearchResults.push({
        id:
          resObj.message_type == "sent"
            ? resObj.to_user?.using_employee_id
            : resObj.from_user?.using_employee_id == 0
            ? ""
            : resObj.from_user?.using_employee_id,
        user_id:
          resObj.message_type == "sent"
            ? resObj.to_user?.using_employee_id
            : resObj.from_user?.using_employee_id == 0
            ? ""
            : resObj.from_user?.using_employee_id,
        name:
          resObj.message_type == "sent"
            ? resObj.to_user.user_name
            : resObj.from_user.user_id == 0
            ? "－"
            : resObj.from_user.user_name,
        date: resObj.created_at,
        content: resObj.message,
        unread_count: resObj?.unread_count,
        url: `${SITE_MAP.THANKS_POINT_MESSAGES}?id=${resObj?.thanks_giving_id}`,
        icon: {
          original: "",
          large: "",
          medium:
            resObj.message_type == "sent"
              ? resObj.to_user.user_image
              : resObj.from_user.user_id == 0
              ? ""
              : resObj.from_user.user_image,
          small: ""
        },
        point: {
          total: resObj.points,
          pointAddition: false,
          state: resObj.message_type
        },
        unread: resObj.has_read === false ? true : false
      });
    });

    this.messagesSearchResultsCount = thanksPointList?.count as number;
    this.handlePagination(thanksPointList);
  }

  handlePagination(thanksPointList: any) {
    const prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      const prevPage = 1;
    }

    const nextPage = this.currentPage + 1;
    const count = thanksPointList?.count ?? 1;
    const maxPage =
      count % this.pageSize >= 1
        ? Math.floor(count / this.pageSize) + 1
        : count / this.pageSize;

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;

    this.pageNavi.baseUrl = SITE_MAP.THANKS_POINT_USER_SPECIFIC + `?id=${this.user}`;
    this.pageNavi.nextPageUrl = this.pageNavi.baseUrl + "page=" + nextPage + this.searchParams;
    this.pageNavi.prevPageUrl = this.pageNavi.baseUrl + "page=" + prevPage + this.searchParams;
  }

  get searchParams(){
    return this.searchKeyword ? `&search=${this.searchKeyword}` : ``;
  }
  
  async doSearch($event: any) {
    this.usersSearchResults = [];
    this.currentPage = 1;
    const searchParam = $event || "";
    const searchPlusCharacter = searchParam.replaceAll("+", "%2B");
    const search = searchPlusCharacter.replaceAll("#", "%23");

    this.searchKeyword = typeof search === undefined ? "" : search;
    await this.getThankPoint(this.currentPage, this.searchKeyword, this.user);
    this.handleURL();
  }

  handleURL() {
    const queryString = window.location.search;
    const title = document.title;
    const baseUrl = `${SITE_MAP.THANKS_POINT_USER_SPECIFIC}?`;
    const tempQs = queryString?.split("&");
    const tempUrl = [];
    for (const iterator of tempQs) {
      if (iterator.includes("search")) {
        tempUrl.push(
          iterator.replace(iterator, `search=${this.searchKeyword}`)
        );
      } else if (iterator.includes("page")) {
        tempUrl.push(
          iterator.replace(iterator, `page=${this.currentPage}`)
        );
      } else {
        tempUrl.push(iterator);
      }
    }

    if (queryString === "") {
      tempUrl.push(`search=${this.searchKeyword}`);
      tempUrl.push(`id=${this.user}`);
      tempUrl.push(`page=${this.pageNavi.currentPage}`);
    }

    const newUrl =
      baseUrl +
      tempUrl
        .filter(Boolean)
        .join("&")
        .replace("?", "");
    window.history.replaceState({}, title, newUrl);
  }
}
